<template>
  <div class='h-mml-xybox' :resp='resp'>
    {{resp.errorMsg}}
  </div>
</template>

<script>
export default {
  name: 'ShowErrorMsg',
  props: {
    resp: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style>

</style>
